import { useState } from 'react';
import { liveQuestStreak, questCount, questDone, questsFor, QUESTS_PER_DAY } from '@brainfart/shared';
import { getQuestState, todayKey } from '../profileStore';

// Today's three quests on the homepage: one quiet row (progress dots, the streak of days with every quest done) that
// opens into the list. Collapsed it is a single line, so the first screen still holds PLAY and the Daily Quiz.
export function QuestsCard() {
  const [open, setOpen] = useState(false);
  const [{ state }] = useState(() => getQuestState());
  const date = todayKey();
  const quests = questsFor(date);
  const done = quests.filter(q => questDone(state.day, q)).length;
  const streak = liveQuestStreak(state.streak, date);
  const finished = done === QUESTS_PER_DAY;

  return (
    <div
      data-testid="quests-card"
      style={{ borderRadius: 18, background: '#16132B', border: `1px solid ${finished ? '#39FF88' : '#2E2860'}`, overflow: 'hidden' }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', width: '100%', minHeight: 52, padding: '0.7rem 1.1rem', textAlign: 'left', color: '#fff' }}
      >
        <span aria-hidden style={{ fontSize: '1.25rem' }}>{finished ? '🎉' : '🎯'}</span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: 'block', fontWeight: 800, fontSize: '0.95rem' }}>{finished ? 'Quests done for today' : "Today's quests"}</span>
          <span style={{ display: 'block', color: '#9a97b3', fontSize: '0.8rem' }}>
            {done}/{QUESTS_PER_DAY} done{streak > 0 ? ` · 🔥 ${streak} day${streak === 1 ? '' : 's'} in a row` : ''}
          </span>
        </span>
        <span aria-hidden style={{ display: 'flex', gap: 5 }}>
          {quests.map(q => (
            <span key={q.id} style={{ width: 10, height: 10, borderRadius: 5, background: questDone(state.day, q) ? '#39FF88' : '#2E2860' }} />
          ))}
        </span>
        <span aria-hidden style={{ color: '#9a97b3', transform: open ? 'rotate(90deg)' : 'none' }}>›</span>
      </button>
      {open && (
        <ul style={{ listStyle: 'none', margin: 0, padding: '0 1.1rem 0.9rem', display: 'flex', flexDirection: 'column', gap: '0.55rem' }}>
          {quests.map(q => {
            const isDone = questDone(state.day, q);
            const count = questCount(state.day, q);
            return (
              <li key={q.id} data-testid="quest" style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', opacity: isDone ? 0.65 : 1 }}>
                <span aria-hidden style={{ fontSize: '1.1rem' }}>{q.icon}</span>
                <span style={{ flex: 1, fontSize: '0.92rem', fontWeight: 600, textDecoration: isDone ? 'line-through' : 'none' }}>{q.title}</span>
                <span style={{ color: isDone ? '#39FF88' : '#9a97b3', fontSize: '0.85rem', fontWeight: 800 }}>{isDone ? '✓' : `${count}/${q.target}`}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
